import { z } from 'zod';

/**
 * Shapes returned by the `getStatus` query. NOT implemented by autopilot yet: ops-desk only calls
 * the query when explicitly enabled. Loose so extra fields pass.
 */
export const timelineEntrySchema = z.looseObject({
  at: z.iso.datetime({ offset: true }),
  stage: z.string(),
  message: z.string(),
});
export type TimelineEntry = z.infer<typeof timelineEntrySchema>;

export const pendingDecisionSchema = z.looseObject({
  decisionId: z.string().min(1),
  kind: z.string(),
  summary: z.string(),
  context: z.record(z.string(), z.unknown()),
  options: z.array(z.looseObject({ value: z.string(), label: z.string() })),
  requiredFields: z.array(z.string()).optional(),
});
export type PendingDecision = z.infer<typeof pendingDecisionSchema>;

export const adhocSubmissionStatusSchema = z.looseObject({
  stage: z.string(),
  status: z.enum(['RUNNING', 'AWAITING_DECISION', 'COMPLETED', 'FAILED', 'CANCELLED']),
  quoteNumber: z.string(),
  timeline: z.array(timelineEntrySchema),
  pendingDecision: pendingDecisionSchema.nullable(),
});
export type AdhocSubmissionStatus = z.infer<typeof adhocSubmissionStatusSchema>;
